import { TestTube, CheckCircle } from 'lucide-react';
import { FormSection } from '../../types/formBuilder';
import { useAppStore } from '../../store/useAppStore';
import { FormPreviewFields } from './preview/FormPreviewFields';
import { LiveJsonPayload } from './preview/LiveJsonPayload';
import { TestingControls } from './preview/TestingControls';
import { DebugSections } from './preview/DebugSections';

interface FormPreviewRendererProps {
  sections: FormSection[];
  workflowPath?: string;
  outputKey?: string;
  creditCost?: number;
}

export const FormPreviewRenderer = ({ 
  sections, 
  workflowPath = 'fal-ai/flux-pro/v1.1',
  outputKey = 'images'
}: FormPreviewRendererProps) => {
  const { session } = useAppStore();

  return (
    <div className="space-y-8 max-w-none">
      {/* Form Sections */}
      <FormPreviewFields
        sections={sections}
        formData={{}}
        formErrors={{}}
        disabled={false}
        onInputChange={() => {}}
      />

      {/* Live Form Testing */}
      <div className="pt-8 border-t border-subtle">
        <h4 className="text-lg font-semibold text-th-primary mb-4 flex items-center space-x-2">
          <TestTube className="w-5 h-5 text-accent" />
          <span>Form Preview</span>
        </h4>
        
        {/* Real-time API Payload Preview */}
        <LiveJsonPayload
          formData={{}}
          workflowPath={workflowPath}
          outputKey={outputKey}
        />

        {/* Info Message */}
        <div className="p-4 bg-status-warning/10 border border-status-warning/30 rounded-lg">
          <div className="flex items-center space-x-2">
            <CheckCircle className="w-5 h-5 text-status-warning" />
            <span className="text-status-warning font-medium">Testing Note</span>
          </div>
          <p className="text-status-warning/70 text-sm">
            Full form testing is available via public pages. Create a public page for this model to test complete functionality.
          </p>
        </div>
        
        {/* Testing Controls - Disabled */}
        <TestingControls
          isSubmitting={false}
          generationProgress=""
          session={session}
          onTestSubmit={() => alert('Testing is available via public pages')}
          onClearForm={() => {}}
        />
        
        {/* Debug Sections */}
        <DebugSections
          formData={{}}
          falRawOutput={null}
        />
      </div>
    </div>
  );
};